import { jsx as _jsx } from "react/jsx-runtime";
import { Swiper as ReactSwiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/scss";
import "swiper/scss/pagination";
import useIsRTL from "@hooks/useIsRTL";
import cn from "classnames";
import { useEffect, useRef, useState } from "react";
import { useWindow } from "@hooks/useWindow";
import useDebounce from "@hooks/useDebounce";
const MobileSwiper = ({ data, displayData, className, slideClassName, maxSlides, loop, setSwiper, setSlideDimentions, spaceBetweenSlides, breakpoints, autoplay, pagination, onSlideChange, loading, trackResize }) => {
    const { isRtl, htmlDirIsChecked } = useIsRTL();
    const [localSwiper, setLocalSwiper] = useState(null);
    const [swiperInitialized, setSwiperInitialized] = useState(false);
    const myWindow = useWindow();
    const widthRef = useRef(null);
    const { debounceFn } = useDebounce({ delay: 100 });
    const slideDimentionsHandler = () => {
        if ((localSwiper === null || localSwiper === void 0 ? void 0 : localSwiper.slides.length) > 0 && setSlideDimentions && !loading) {
            const maxW = Math.max(...localSwiper.slides.map((o) => o.clientWidth));
            const maxH = Math.max(...localSwiper.slides.map((o) => o.clientHeight));
            setSlideDimentions({ height: maxH, width: maxW });
            localSwiper.update();
        }
    };
    useEffect(() => {
        slideDimentionsHandler();
    }, [localSwiper, loading]);
    const handleResize = () => {
        if (myWindow.innerWidth === widthRef.current) {
            return;
        }
        widthRef.current = window.innerWidth;
        setSlideDimentions({ height: null, width: null });
        debounceFn(slideDimentionsHandler);
    };
    useEffect(() => {
        if (!trackResize) {
            return () => { };
        }
        const sub = myWindow && myWindow.addEventListener("resize", handleResize);
        return () => {
            sub && myWindow.removeEventListener("resize", handleResize);
        };
    }, [myWindow, localSwiper, loading, trackResize]);
    return (_jsx("div", { className: "flex w-full flex-col", children: htmlDirIsChecked && (_jsx(ReactSwiper, { dir: isRtl ? "rtl" : "ltr", centeredSlides: false, autoplay: autoplay !== null && autoplay !== void 0 ? autoplay : { delay: 5000 }, pagination: pagination !== null && pagination !== void 0 ? pagination : { clickable: false }, slidesPerView: maxSlides !== null && maxSlides !== void 0 ? maxSlides : "auto", spaceBetween: spaceBetweenSlides !== null && spaceBetweenSlides !== void 0 ? spaceBetweenSlides : 0, modules: [Pagination, Autoplay], init: false, onInit: (swiper) => {
                if (setSwiper) {
                    setSwiper(swiper);
                }
                if (!swiperInitialized && swiper) {
                    setLocalSwiper(swiper);
                    setSwiperInitialized(true);
                }
            }, loop: loop, className: cn("h-full", className), breakpoints: breakpoints, onSlideChange: (swiper) => onSlideChange && onSlideChange(swiper), children: data.map((selectedSlide, i) => (_jsx(SwiperSlide, { className: cn("h-auto w-full", slideClassName), children: selectedSlide && displayData(selectedSlide) }, i))) })) }));
};
export default MobileSwiper;
